import React from 'react';
import StyleButton from './StyleButton';
import { useSelector } from 'react-redux';
import _ from 'lodash';

const INLINE_STYLES = [
  { label: 'Bold', icon: 'bold', style: 'BOLD' },
  { label: 'Italic', icon: 'italic', style: 'ITALIC' },
  { label: 'Underline', icon: 'underline', style: 'UNDERLINE' },
];

const Inline = props => {
  const enabledEditorId = useSelector(state => state.design.enabledEditorId);
  const currentStyle = useSelector(state => state.design.inlineStyles);

  const onToggle = inlineStyle => {
    const newStyle = {
      type: 'inline',
      all: props.entityId !== enabledEditorId,
      value: inlineStyle,
    };
    props.onChange(newStyle);
  };

  return INLINE_STYLES.map(type => {
    return (
      <StyleButton
        key={type.label}
        active={currentStyle && currentStyle.has(type.style)}
        onToggle={onToggle}
        {...type}
      />
    );
  });
};

export default Inline;
